(function() {
    'use strict';
    angular.module('emarket.main.province').factory('Province', ['restmod', function(restmod) {
        var rest = restmod.mixin(function() {
            this.define('Model.unpackMany', function(_rawData) {
                return _rawData;
            });
            this.define('Model.unpack', function(rawData, record) {
                record = record
                    .sort(function(a, b) {
                        if (a.slug === 'distrito-nacional') {
                            return -1;
                        }
                        if (b.slug === 'distrito-nacional') {
                            return 1;
                        }
                        if (a.slug !== 'distrito-nacional' && b.slug !== 'distrito-nacional') {
                            if (/santo-domingo-/.test(a.slug)) {
                                return -1;
                            }
                            if (/santo-domingo-/.test(b.slug)) {
                                return 1;
                            }
                            return a.name - b.name;
                            // if(a.slug === 'santo-domingo-norte' && b.slug !== 'santo-domingo-este') {
                            //     return -1;
                            // }
                            // if(b.slug === 'santo-domingo-norte' && a.slug !== 'santo-domingo-este') {
                            //     return 1;
                            // }
                        }
                    })
                    .filter(function(province) {
                        return province.slug !== 'santo-domingo';
                    });
                return record;
            });
        });
        var province = restmod.model('/provinces');
        return province;
    }]);
}());
